import ApplicationLoader from "@/ApplicationLoader";

import PollContainer from "./PollContainer";

const AppLoader = new ApplicationLoader(PollContainer);

AppLoader.start();
